/**
 * /* eslint-disable react/jsx-props-no-spreading
 *
 * @format
 */

import React, { forwardRef } from "react";

const BiggerLogo = forwardRef(
  (
    {
      width = 169,
      height = 68,
      style = {},
      ...restProps
    }: { width?: number | undefined; height?: number | undefined; style?: {} },
    ref
  ) => (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 169 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g filter="url(#filter0_f_489_24260)">
        <path
          d="M54.839 30.5478C54.839 43.4575 44.3215 53.9228 31.3475 53.9228C18.3735 53.9228 7.85596 43.4575 7.85596 30.5478C7.85596 17.6382 18.3735 7.17285 31.3475 7.17285C44.3215 7.17285 54.839 17.6382 54.839 30.5478Z"
          fill="url(#paint0_angular_489_24260)"
        />
      </g>
      <g filter="url(#filter1_f_489_24260)">
        <ellipse
          cx="32.0587"
          cy="31.2561"
          rx="22.7797"
          ry="22.6667"
          fill="url(#paint1_angular_489_24260)"
        />
      </g>
      <g filter="url(#filter2_f_489_24260)">
        <ellipse
          cx="34.9066"
          cy="34.0899"
          rx="22.7797"
          ry="22.6667"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.3858 24.6921C61.8971 23.9082 60.1998 23.4642 58.3982 23.4642C52.5009 23.4642 47.7202 28.2212 47.7202 34.0892C47.7202 37.8783 49.7135 41.2042 52.7137 43.0851L54.1391 40.6285C51.9896 39.2395 50.5679 36.8296 50.5679 34.0893C50.5679 29.786 54.0737 26.2976 58.3984 26.2976C59.6812 26.2976 60.8919 26.6045 61.9605 27.1486L63.3858 24.6921ZM54.8357 41.0296C55.9044 41.5739 57.1154 41.8809 58.3984 41.8809C62.7231 41.8809 66.2289 38.3925 66.2289 34.0893C66.2289 31.3487 64.807 28.9386 62.6571 27.5496L64.0824 25.0932C67.0827 26.9741 69.0761 30.3 69.0761 34.0892C69.0761 39.9573 64.2955 44.7142 58.3982 44.7142C56.5965 44.7142 54.899 44.2702 53.4103 43.4862L54.8357 41.0296ZM96.1272 25.1172L98.9747 23.7006V44.0061H96.1272V25.1172ZM133.856 23.4642C135.657 23.4642 137.355 23.9082 138.843 24.6921L137.418 27.1488C136.349 26.6046 135.138 26.2976 133.855 26.2976C129.531 26.2976 126.025 29.786 126.025 34.0893C126.025 36.8298 127.447 39.2398 129.596 40.6288L128.171 43.0851C125.171 41.2041 123.178 37.8783 123.178 34.0892C123.178 28.2212 127.958 23.4642 133.856 23.4642ZM133.855 41.8809C132.572 41.8809 131.362 41.574 130.293 41.0298L128.868 43.4862C130.357 44.2702 132.054 44.7142 133.856 44.7142C139.753 44.7142 144.534 39.9573 144.534 34.0892C144.534 30.3 142.54 26.9741 139.54 25.0931L138.114 27.5499C140.264 28.9389 141.686 31.3489 141.686 34.0893C141.686 38.3925 138.18 41.8809 133.855 41.8809ZM163.042 25.1163L165.89 23.6996V44.0051H164.94H163.042H162.33L153.076 28.894V23.6996L163.042 39.7909V25.1163ZM148.805 25.1165L151.653 23.6998V44.0053H148.805V25.1165ZM29.212 23.7006L26.3645 25.1172V44.0061H29.212V23.7006ZM43.4489 23.7007L40.6014 25.1174V32.6737H30.6359V35.5071H40.6014V44.0062H43.4489V35.5071H43.4496L43.4489 35.5064V23.7007ZM116.516 24.1722H104.669V27.0056H114.482L116.516 24.1722ZM118.195 24.1724H121.042V25.1642L109.55 41.1724H121.754V44.0057H106.093L104.669 44.0057V43.0142L118.195 24.1724ZM76.1949 24.1722L73.3474 25.5889V44.0056H76.1949V24.1722ZM84.0257 34.0892V34.0887H81.1782H77.6189L87.1104 44.0053H90.907L83.9579 36.922H84.0254V36.9224H84.0254C87.5638 36.9224 90.4322 34.0682 90.4322 30.5474C90.4322 27.1056 87.6911 24.3008 84.2625 24.1767V24.1724H84.0254H77.6187V27.0057H84.0254V27.0059C85.9909 27.0061 87.5843 28.5917 87.5843 30.5476C87.5843 32.5033 85.9911 34.0889 84.0257 34.0892Z"
        fill="url(#paint2_linear_489_24260)"
      />
      <defs>
        <filter
          id="filter0_f_489_24260"
          x="5.71517"
          y="5.03207"
          width="51.2647"
          height="51.0316"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.07039"
            result="effect1_foregroundBlur_489_24260"
          />
        </filter>
        <filter
          id="filter1_f_489_24260"
          x="8.20866"
          y="7.51907"
          width="47.7001"
          height="47.4741"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.535196"
            result="effect1_foregroundBlur_489_24260"
          />
        </filter>
        <filter
          id="filter2_f_489_24260"
          x="11.8594"
          y="11.1556"
          width="46.0945"
          height="45.8685"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.133799"
            result="effect1_foregroundBlur_489_24260"
          />
        </filter>
        <radialGradient
          id="paint0_angular_489_24260"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(31.3475 30.5478) rotate(90) scale(23.375 23.4915)"
        >
          <stop offset="0.0989583" stopColor="#6666FF" />
          <stop offset="0.354167" stopColor="#5883FF" />
          <stop offset="0.604167" stopColor="#5AD3FF" />
        </radialGradient>
        <radialGradient
          id="paint1_angular_489_24260"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.0587 31.2561) rotate(90) scale(22.6667 22.7797)"
        >
          <stop offset="0.0989583" stopColor="#6666FF" />
          <stop offset="0.354167" stopColor="#5883FF" />
          <stop offset="0.604167" stopColor="#5AD3FF" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_489_24260"
          x1="12.2373"
          y1="49.0893"
          x2="168.237"
          y2="25.5892"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2351DF" />
          <stop offset="1" stopColor="#229BFF" />
        </linearGradient>
      </defs>
    </svg>
  )
);

export default BiggerLogo;
